import React, { Component } from 'react';
import { MuiThemeProvider } from '@material-ui/core/styles';
import Router from './Router';
import theme from './config/themes/default';
import { Provider } from 'react-redux';
import store from './reduxStore';




// Set auth token in localstorage if it's not set or has changed
store.subscribe( () => {
	let auth = store.getState().auth;

	if ( localStorage.token !== auth.token ) {
		if ( auth.token ) {
			//console.log('updated token')
			localStorage.setItem( 'token', auth.token );
			localStorage.setItem( 'sid', auth.sid );
		} else {
			localStorage.removeItem( 'token' );
			localStorage.removeItem( 'sid' );
			//console.log('removed token')
		}
	}
} );



class App extends Component {
	render() {
		return (
			<Provider store={store}>
				<MuiThemeProvider theme={theme}>
					<Router />
				</MuiThemeProvider>
			</Provider>
		);
	}
}



export default App;
